export const sanityClientConfig = {
  // replace this id with the one you find in /studio/sanity.json
  projectId: 'n9rwkkn1',
  // make sure that the dataset name is the same as the one in /studio/sanity.json
  dataset: 'prod',
  useCdn: false
}
